import React, { useEffect, useState } from "react";
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";
import { format } from "date-fns";
import { BrowserProvider } from "ethers";

const BalanceChart = ({ walletProvider, isConnected }) => {
  const [data, setData] = useState([]);

  const fetchBalance = async () => {
    if (!isConnected || !walletProvider) return;

    try {
      const provider = new BrowserProvider(walletProvider);
      const signer = await provider.getSigner();
      const address = await signer.getAddress();

      const balanceWei = await provider.getBalance(address);
      const balanceEth = Number(balanceWei) / 1e18;

      // Add new entry
      setData(prev => [
        ...prev,
        { time: new Date(), balance: balanceEth }
      ]);
    } catch (err) {
      console.error("Balance fetch error:", err);
    }
  };

  // Fetch balance every 30s (you can change to 1 min / 5 min)
  useEffect(() => {
    if (isConnected) {
      fetchBalance();
      const interval = setInterval(fetchBalance, 30000);
      return () => clearInterval(interval);
    }
  }, [isConnected, walletProvider]);

  return (
    <div style={{ width: "100%", height: "100%", background: "#0a0a0a", borderRadius: "12px", padding: "16px" }}>
      <ResponsiveContainer>
        <LineChart data={data}>
          <XAxis
            dataKey="time"
            tickFormatter={(time) => format(new Date(time), "MM-dd HH:mm")}
            stroke="#888"
          />
          <YAxis stroke="#888" domain={["auto", "auto"]} />
          <Tooltip
            labelFormatter={(time) => format(new Date(time), "PPpp")}
            formatter={(value) => [`${value.toFixed(6)}`, "Balance"]}
            contentStyle={{ backgroundColor: "#111", border: "1px solid #333" }}
          />
          <Line
            type="monotone"
            dataKey="balance"
            stroke="#8b5cf6" // purple
            strokeWidth={2}
            dot={false}
            activeDot={{ r: 6, fill: "#fff" }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default BalanceChart;
